// src/components/Support/EditDrawer.jsx
import React from 'react';
import { useDispatch } from 'react-redux';
import { Drawer, Form, Button, SelectPicker, Message, useToaster } from 'rsuite';
import { updateClaim } from '../../../services/claim.service';
import { useTranslation } from 'react-i18next';

interface EditDrawerProps {
  open: boolean;
  onClose: () => void;
  claim: any;
  type?: string; // Add type prop
}

const EditDrawer: React.FC<EditDrawerProps> = ({ open, onClose, claim, type = '' }) => {
  const dispatch = useDispatch();
  const toaster = useToaster();
  const [formValue, setFormValue] = React.useState({
    status: claim?.status || '',
    CommentUser: claim?.CommentUser || '',
    CommentAdmin: claim?.CommentAdmin || ''
  });
  const { t } = useTranslation();

  React.useEffect(() => {
    if (claim) {
      setFormValue({
        status: claim.status || '',
        CommentUser: claim.CommentUser || '',
        CommentAdmin: claim.CommentAdmin || ''
      });
    }
  }, [claim]);

  const statusOptions = [
    { label: t('Pending'), value: 'pending' },
    { label: t('Processing'), value: 'processing' },
    { label: t('Closed'), value: 'closed' }
  ];

  const handleSubmit = async () => {
    if (claim) {
      try {
        await dispatch(updateClaim(claim, formValue, type));
        toaster.push(
          <Message type="success" duration={3000}>
            Claim updated successfully
          </Message>
        );
        onClose();
      } catch (error) {
        toaster.push(
          <Message type="error" showIcon>
            {t('Failed to update claim:')} {t(error.message)}
          </Message>
        );
      }
    }
  };

  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Edit Claim')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleSubmit} appearance="primary">
            {t('Save')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Status')}</Form.ControlLabel>
            <Form.Control name="status" accepter={SelectPicker} data={statusOptions} block />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('User Comment')}</Form.ControlLabel>
            <Form.Control name="CommentUser" componentClass="textarea" rows={3} />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Admin Comment')}</Form.ControlLabel>
            <Form.Control name="CommentAdmin" componentClass="textarea" rows={3} />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default EditDrawer;
